export default __webpack_public_path__ + "static/media/Sebastian_Sæby_uden_logo_til_sidst.8294c0c9.mp4";